<div class="loading-indicator" role="status" aria-live="polite">
    <img
        class="loading-indicator__logo"
        [src]="logoPath"
        alt=""
    />
    <div class="loading-indicator__text">{{ message }}</div>
</div>
